import { Pipe, PipeTransform } from '@angular/core';

import { AnyValues } from '../interfaces/undetermined';

@Pipe({ name: 'setAlertType' })
export class SetAlertTypePipe implements PipeTransform {

  /* transform(): Pipe que devuelve el valor de la propiedad de un objeto si la llave esta entre un rango específico
    value: valor con el que se medirá el rango
    args: Objeto a comparar, sintaxis: {'nombre a retornar':'valor de coincidencia'},
    establecer el último elemento como: {'nombre a retornar':'end'}, establecer 2 o más valores
  */
  transform(value: number, args: AnyValues): string {
    // type: valor a retornar
    let type = "success";
    // keys: llaves del Objeto
    const keys: string[] = Object.keys(args);
    // ↓ Itera las llaves para verificar si está entre el rango
    for (let i = 0; i < keys.length; i++) {
      if (i === 0) {
        // ↓ si es la primera posición validará menor que
        if (value < args[keys[i]]) { type = keys[i]; }
      } else if (i === keys.length - 1) {
        // ↓ si no es la primera posición o la última validará mayor o igual que
        if (value >= args[keys[i - 1]]) { type = keys[i]; }
      } else {
        // ↓ si es la útilma posición validará mayor que
        if (value >= args[keys[i - 1]] && value < args[keys[i]]) { type = keys[i]; }
      }
    }
    // ↓ Devuelve la propiedad del objeto que cumple con la condición
    return type;
  }

}
